// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xAih","top":"styles_top__2tyaI","left":"styles_left__wxtI8","description":"styles_description__1BfOc"};